function e(e){return typeof e==`number`?`${e}px`:e}export{e as toPx};
//# sourceMappingURL=to-px.js.map